import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from '../layout/main-layout/main-layout.component';
import { SalesComponent } from './sales.component';
import { Layouts } from '../app.component'
import { GeneralDashComponent } from './general-dash/general-dash.component';
import { MaintainWatchComponent } from './maintain-watch/maintain-watch.component';
import { ListWatchComponent } from './list-watch/list-watch.component';
import { CreamsDashComponent } from './creams-dash/creams-dash.component';
import { MHDashComponent } from './mh-dash/mh-dash.component';
import { GeneralDashSearchRangeComponent } from './general-dash-search-range/general-dash-search-range.component';
import { TimeSheetDashComponent } from './timesheet-dash/timesheet-dash.component';
import { GeneralOverviewComponent } from './general-overview/general-overview.component';
import { LastSevenDaysComponent } from './last-seven-days/last-seven-days.component';

const routes: Routes = [
  {
    path: 'sales',
    component: SalesComponent,
    data: { layout: Layouts.Main }
  },
  {
    path: 'sales/generaldash',
    component: GeneralDashComponent,
    data: { layout: Layouts.Main  },
  },
  {
    path: 'sales/storesdash',
    component: SalesComponent,
    data: { layout: Layouts.Main  },
  },
  { path: 'sales/general-overview', 
    component: GeneralOverviewComponent,
    data: { layout: Layouts.Main  }, 
  },
  { path: 'sales/last-seven-days', 
    component: LastSevenDaysComponent,
    data: { layout: Layouts.Main  }, 
  },
  {
    path: 'sales/create',
    component: MaintainWatchComponent,
    data: { layout: Layouts.Main  },
  },
  {
    path: 'sales/list',
    component: ListWatchComponent,
    data: { layout: Layouts.Main 
    },
  },
  {
    path: 'sales/creamsdash',
    component: CreamsDashComponent,
    data: { layout: Layouts.Main 
    },
  },
  {
    path: 'sales/mhdash',
    component: MHDashComponent,
    data: { layout: Layouts.Main 
    },
  },
  {
    path: 'sales/generaldashsearchrange',
    component: GeneralDashSearchRangeComponent,
    data: { layout: Layouts.Main 
    },
  },
  {
    path: 'sales/timesheetdash',
    component: TimeSheetDashComponent,
    data: { layout: Layouts.Main 
    },
  },
  {
    path: 'salescreate/:id',
    component: MaintainWatchComponent,
    data: { layout: Layouts.Main 
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalesRoutingModule { }
